import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import * as WebUploader7 from 'webuploader';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';

@Component({
  selector: 'sw-input-upload',
  templateUrl: './sw-input-upload.component.html',
  styleUrls: ['./sw-input-upload.component.css']
})
export class SwInputUploadComponent implements OnInit {
  constructor(
    private http:SwHttpClientService,
    private systemId: SystemIdService,
    private box:SwMassageBoxService,
    private Jwt:SwJwtService,
    ) { }

  /**
   * 上传策略
   */
  @Input() code:string; 

  /**
   * 上传成功之后将文件信息抛出
   */
  @Output() votedFile = new EventEmitter()  

  /**
   * @ignore
   * webUploader 文件上传初始化的 uploader 的id
   */
  @Input() uploaderId: any

  /**
   * @ignore
   * 是否可以多张上传, 默认可以
   */
  @Input() multiple: boolean = false

  /**
   * @ignore
   * 上传路径--输入属性，如果业务端不传此参数，那么就将空值传入上传接口，后台会判断是否有值，没有的话，后台会从策略中读取
   */
  @Input() uploadPath:string = ''

  /**
   * @ignore
   * webUploader 文件上传初始化的 uploader
   */
  inputUploader: any

  /**
   * @ignore
   * 显示正在上传的状态
   */
  loading: boolean = false
  
  /**
   * @ignore
   * 文件处理微服务api
   */
  fileUrl:string = environment.fileWebAPI

  /**
   * @ignore
   * 显示正在上传的状态
   */
  status: string = ''

  /**
   * @ignore
   * 当文件添加到队列中之后,获取文件对象数组
   */
  fileList:any[] = []

  /**
   * @ignore
   * 文件上传成功的uuid组成的数组
   */
  successUuids:any[] = []

  /**
   * @ignore
   * 选择的文件到上传队列之后有没有出现错误,默认没有，如果有，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
   */
  hasError :boolean = false

  /**
   * @ignore
   * 创建上传对象需要的参数
   */
  option = {
    server:this.fileUrl + "file/fileUpload", //文件接收服务器
    auto: true,   //自动上传
    resize: false,  //
    dnd: '#uploader',   //指定 Drag And Drop 拖拽的容器,如果不知道,则不启动
    paste: '#uploader',  //指定监听paste事件的容器,如果不指定则不起都过此功能.此功能为通过粘贴来添加截屏的图片,建议设置为document.body
    pick: {
      id: '#filePicker',
      label: '选择文件',
      multiple: true,   //默认多张上传
    },
    accept: {   //只允许上传图片文件
      title: '',
      extensions: 'gif,jpg,jpeg,bmp,png',
      // mimeTypes: 'image/*',
      //点击选择文件之后会有延迟,解决方法:
      mimeTypes: 'image/gif,image/jpg,image/jpeg,image/png,image/bmp'
    },
    fileNumLimit:100 , 
    compress:false,
    chunked:true,     //分片上传大文件
    chunkSize:1024*512,
    chunkRetry:3,     // 如果某个分片由于网络出现问题错误,允许自动上传多少次
    threads:5,        //最大上传并发数
    method:'Post',
    fileSizeLimit:undefined,  //验证文件总大小是否超出限制,超出则不允许加入队列
    fileSingleSizeLimit:undefined,  //验证单个文件大小是否超出限制,超出则不允许加入队列
    duplicate:true,   //允许重复上传文件
  
  }

  /**
   * @ignore
   */
  ngOnInit() {
    // this.uploaderId = 'input' + new Date().getTime();
    // this.option.pick.id = '#'+ this.uploaderId
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.uploaderId = this.uploaderId || this.code + String(new Date().getTime())
    this.option.pick.id = '#'+ this.uploaderId
    this.http.Get(this.fileUrl +'fileConfig/queryFileConfigOfUploadBeforeByCode?code='+this.code)
    .subscribe(ret=>{
      if(ret && ret.code == 200){
        let uploadObj = ret.data;
        this.option.fileSingleSizeLimit = uploadObj.config.allowSize? uploadObj.config.allowSize *1024 *1024 : undefined;
        this.option.accept.extensions = uploadObj.suffix
        this.option.pick.multiple = this.multiple

        // bug: 允许文件类型中有 pdf文件,它的mimetype是application/x-pdf,但是在选择文件的时候,自定义文件中没有出现pdf文件
        // 注意: options5.accept.mimeTypes 属性是指定 input[type="file"] 的 accpet 属性的值
        /* // 解决方法1: 将 accept="image/jpg,application/x-pdf" 改为 accept="image/jpg,application/pdf"  ,这要直接在系统配置中修改
        this.options5.accept.mimeTypes = this.uploadObj.type   //accept="image/jpg,application/x-pdf " 
        */
        // 解决方法2: 将 accept="doc,docx,jpg,jpeg,png,bmp,zip,pdf" 需要改成 accept=".doc,.docx,.jpg,.jpeg,.png,.bmp,.zip,.pdf" (现在用的方法,如下3行代码)
        let arr = uploadObj.suffix.split(',')  
        arr = arr.map(item=>'.'+item)
        this.option.accept.mimeTypes = arr.join(',')
        // this.uploadPath = uploadObj.config.filePath
        this.inputUploader = WebUploader7.create(this.option)
        this.clickToSelect()
      }
    })
  }

  ngAfterViewInit(): void {
    if(!this.inputUploader){
      this.inputUploader = WebUploader7.create(this.option)
      this.clickToSelect()
    }
  }

  /**
  * 点击选择附件按钮,将之前的队列清空,重新选择要上传的文件
  * @ignore
  */
  clickToSelect(){
    this.inputUploader.refresh()
    //将上次的已将上传的文件信息清空
    //当文件加到队列之前
    this.inputUploader.on('beforeFileQueued',(file)=>{
      //每次有文件加入队列，先把 hasError初始化一下
      this.hasError = false
      if(this.option.accept.extensions && this.option.accept.extensions.indexOf(file.ext.toLocaleLowerCase()) == -1){
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        //没有这个后缀
        this.box.danger('文件格式不正确')
        return
      }
      if(file.size > this.option.fileSingleSizeLimit){
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        this.box.danger(file.name+'大小超过限制')
        return
      }
      if(file.size == 0){ 
        //在加入队列之前就发现错误，不能上传该文件，之后的 this.fileUploader.on('error',(type)=>{}） 里面就不要再次提示了
        this.hasError = true
        this.box.danger(file.name + ' 的文件大小为0KB，请选择其他文件上传')
        return
      }
    })

    //当一批文件添加到队列以后触发
    this.inputUploader.on('filesQueued',(files)=>{
      //当有文件被添加到队列的时候,如果需要再次选择文件,这里需要重新实体化,将上一次的待上传文件信息清空
      this.inputUploader.refresh()
      //不论上次上传是否成功,将待上传文件和已上传成功的id全部清空
      //将待上传文件清空
      this.fileList = []
      //将上传成功的文件队列清空
      this.successUuids = []
      if(!this.option.pick.multiple){
        //单张上传, 上传队列中也只有一个文件
        this.fileList.push(files[0])  //添加一个文件到待上传文件中
      } else {
        this.fileList = this.fileList.concat(files)
      }
    }) 

    //文件上传之前触发,设置参数
    this.inputUploader.on('uploadBeforeSend',(obj, data, headers)=>{
        //增加请求头
        headers['AuthorizationU'] = this.Jwt.getToken('token'),
        data.id = obj.file.id ,              //wu_id,webUpload组件自己排的ID，通过此参数获取相应MD5值
        data.size = obj.file.size ,          //文件总文件字节大小
        data.byteNow = obj.blob.size ,       //定义的每个分片的字节大小
        data.chunks = obj.chunks ,           //总分片数
        data.chunk = obj.chunk ,             //当前分片数，当前是第几分片
        data.name = obj.file.name ,          //文件名
        data.file = JSON.stringify(obj.blob),  //分片对象
        data.sysId = this.systemId.getSystemId(),                   //系统编号 随便写
        data.code = this.code ? this.code : 'aa',                //策略id
        data.uploadPath = this.uploadPath,             //上传路径 随便写的字符串
        data.uploadDirectory = environment.uploadDirectory           //项目路径
    })

    //上传过程,每个分片对象及图片的上传进度
    this.inputUploader.on("uploadProgress",(file:File,percentage:Number)=>{
      if(percentage > 0){
        this.status = 'loading' 
      }
    })

    //上传成功触发
    this.inputUploader.on('uploadSuccess',(file,response)=>{
      if(response.code == 200){
        this.successUuids.push(response.data.uuid)
        if(this.successUuids.length == this.fileList.length){
          //如果队列中的文件数量和上传成功的文件数量一致,说明全部上传成功
          this.status = 'success'
          //调用查询文件的方法,将查到的数组抛出
          this.getVotedFiles(this.successUuids)
        }
      } else {
        //相当于上传失败
        file.completeMsg = response.msg
        file.completeCode = response.code
      }
    })

    //上传失败触发
    this.inputUploader.on('uploadError',(file,reason)=>{
      this.status = 'error'
      setTimeout(() => {
        this.status = ''
      }, 3000);
      this.box.danger("上传失败")
    })

    //校验不通过时发生
    this.inputUploader.on('error',(type)=>{
      //如果这里的校验没通过，而加入到队列时没发现这个问题，就提示
      if(type == 'Q_TYPE_DENIED' && !this.hasError){
        this.box.danger('文件校验不通过')
      } 
    })

    //解决第一次选择文件没有上传,重新选择文件出现队列错误的问题
    this.inputUploader.reset()
  }

  //根据uuids查询上传成功的文件信息,并抛出
  getVotedFiles(uuids){
    let datas = {
      ids:uuids
    }
    this.http.Post(this.fileUrl + "fileInfo/queryByIdList" , datas).subscribe(res=>{
      if(res && res.code == 200){
        let resArr = res.data.filter(item=> !item.isDeleted)  //过滤掉伪删除的文件
        if(this.multiple){
          //如果是多张上传,就抛出数组
          //将成功上传的文件信息抛出
          this.votedFile.emit(resArr)
        } else {
          //如果是单张上传,就抛出文件对象,还是和之前一样,避免报错
          this.votedFile.emit(resArr[0])
        }
        setTimeout(() => {
          this.status = ''
        }, 3000);
      } else{
        this.box.danger("网络错误,无法获取列表")
      }
    })
  }

}
